import Vue from 'vue';
import CryptoJS from 'crypto-es'; //wwa

export function makeToast(obj) {
    let _default = {
        type: 'default',
        duration: 3000,
        dismissible: true,
        queue: true,
        position: 'bottom',
    };
    const toast = $.extend(_default, obj);
    Vue.$toast.open(toast);
}

export const Auth = {
    iv: typeof CryptoJS === 'undefined' ? '' : CryptoJS.enc.Base64.parse(''),
    encrypt: function(data, key) {
        if (typeof CryptoJS === 'undefined') {
            throw new $ex.JsExecutionFailed(new Error('CryptoJS is Not defined'), 'utils - Auth.encrypt');
        }

        if (typeof data === 'string') {
            let _data = data.slice();
            return CryptoJS.AES.encrypt(_data, key, {
                iv: this.iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }).toString();
        } else {
            return CryptoJS.AES.encrypt(JSON.stringify(data), key, {
                iv: this.iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }).toString();
        }
    },
    decrypt: function(data, key) {
        if (typeof CryptoJS === 'undefined') {
            throw new $ex.JsExecutionFailed(new Error('CryptoJS is Not defined'), 'utils - Auth.decrypt');
        }
        return CryptoJS.AES.decrypt(data, key, {
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }).toString(CryptoJS.enc.Utf8);
    },
};

export function hospitalAppDomain() {
    if (location.origin.includes('dev') || location.origin.includes('local')) {
        return 'https://common-ui.lemonhc.com';
    } else {
        return 'https://mcare.lemonhc.com';
    }
}
